import styles from "../Select.module.css";
import { MembershipDetails } from "./MembershipDetails";
import { MembershipOptionsList } from "./MembershipOptionsList";
import type { components } from "../../../../../types/schema-lending";

type Membership = components["schemas"]["Membership"];

interface ExistingMembershipOptionProps {
  selected: boolean;
  label: string;
  memberships: Membership[];
  selectedMembership: Membership | undefined;
  selectedMembershipCoreUserId: string | null;
  onSelectOption: () => void;
  onSelectMembership: (value: string) => void;
}

function ExistingMembershipOption({
  selected,
  label,
  memberships,
  selectedMembership,
  selectedMembershipCoreUserId,
  onSelectOption,
  onSelectMembership,
}: ExistingMembershipOptionProps) {
  return (
    <div
      className={`${styles.optionCard} ${styles.optionCardContainer} ${selected ? styles.optionCardSelected : ""}`}
    >
      <button
        type="button"
        className={styles.optionCardButton}
        aria-pressed={selected}
        aria-expanded={selected}
        onClick={onSelectOption}
      >
        <div className={styles.optionCardContent}>
          <div className={styles.optionBody}>
            <div className={`${styles.optionIcon} ${selected ? styles.optionIconSelected : ""}`}>
              <span className="narmi-icon-users fontSize--l" />
            </div>

            <div className={styles.optionMain}>
              <div className={styles.optionLabel}>{label}</div>
            </div>
          </div>
        </div>
      </button>

      {selected && memberships.length === 1 && selectedMembership ? (
        <MembershipDetails membership={selectedMembership} />
      ) : null}

      {selected && memberships.length > 1 ? (
        <MembershipOptionsList
          memberships={memberships}
          selectedMembershipCoreUserId={selectedMembershipCoreUserId}
          onSelectMembership={onSelectMembership}
        />
      ) : null}
    </div>
  );
}

export { ExistingMembershipOption };
